import * as React from 'react';

import type { Location, NavigationHistory } from './createHistory';

/**
 * Context passing the history controller down the tree.
 */
export const HistoryContext = React.createContext<NavigationHistory | null>(null);

/**
 * Context with the latest location.
 */
export const LocationContext = React.createContext<Location | null>(null);
